<template>
  <div>
    <div class="audio-icon" @click="togglePlay">
      <img v-if="isPlaying" src="@/assets/annualReport/play.png" />
      <img v-else src="@/assets/annualReport/pause.png" />
    </div>
    <audio
      ref="audioPlayer"
      loop
      src="@/assets/annualReport/morningCoffee.mp3"
    ></audio>
  </div>
</template>

<script>
// 引入你的封面图（建议使用正方形的高清图，至少 512x512）
// 注意：请确保路径正确，或者换成你项目里的 logo 图片
import coverImage from "@/assets/annualReport/music_play_icon.png";

export default {
  data() {
    return {
      isPlaying: false,
      audioElement: null,
      wasPlayingBeforeHidden: false,
      originalTitle: "", // 用来存储页面原本的标题
      playTitle: "♫ 正在播放：库迪咖啡年度旅程", // 播放时显示的标题
    };
  },
  mounted() {
    this.audioElement = this.$refs.audioPlayer;
    // 1. 保存页面原本的标题
    this.originalTitle = document.title;

    // 2. 配置 iOS 锁屏媒体信息 (Media Session API)
    this.initMediaSession();

    document.addEventListener("visibilitychange", this.handleVisibilityChange);

    this.audioElement.addEventListener("play", () => {
      this.isPlaying = true;
      // 3. 播放时：修改浏览器标题
      document.title = this.playTitle;
      // 再次确保锁屏信息生效（防止被其他音频覆盖）
      this.updateMediaSessionState("playing");
    });

    this.audioElement.addEventListener("pause", () => {
      this.isPlaying = false;
      // 4. 暂停时：恢复原标题
      document.title = this.originalTitle;
      this.updateMediaSessionState("paused");
    });
  },
  beforeDestroy() {
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    // 离开页面时恢复标题
    document.title = this.originalTitle;
  },
  methods: {
    togglePlay() {
      if (this.isPlaying) {
        this.audioElement.pause();
      } else {
        this.audioElement.play();
      }
    },

    // --- 核心方法：配置锁屏信息 ---
    initMediaSession() {
      if ("mediaSession" in navigator) {
        // 设置锁屏界面的元数据
        navigator.mediaSession.metadata = new MediaMetadata({
          title: "2025年度总结", // 锁屏第一行大字
          artist: "库迪咖啡 Cotti Coffee", // 锁屏第二行小字
          album: "年度回顾", // 锁屏第三行（部分系统显示）
          artwork: [
            {
              src: coverImage, // 封面图路径
              sizes: "512x512", // 尺寸建议
              type: "image/png",
            },
          ],
        });

        // 绑定锁屏界面的控制按钮事件（支持耳机线控和锁屏点击）
        navigator.mediaSession.setActionHandler("play", () => {
          this.audioElement.play();
        });
        navigator.mediaSession.setActionHandler("pause", () => {
          this.audioElement.pause();
        });
      }
    },

    // 更新播放状态，有的系统需要这个来决定显示播放还是暂停图标
    updateMediaSessionState(state) {
      if ("mediaSession" in navigator) {
        navigator.mediaSession.playbackState = state;
      }
    },

    handleVisibilityChange() {
      if (document.hidden) {
        this.wasPlayingBeforeHidden = this.isPlaying;
        if (this.isPlaying) {
          this.audioElement.pause();
        }
      } else {
        if (this.wasPlayingBeforeHidden) {
          this.audioElement.play();
          this.wasPlayingBeforeHidden = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.audio-icon {
  width: 64px;
  height: 64px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer; /* 增加鼠标手势 */
  z-index: 100; /* 确保层级够高 */
  > img {
    width: 64px;
    height: 64px;
  }
}
</style>
